<template>
    <div>
        <v-row no-gutters class="mt-3 mb-4">
            <v-col cols="6" class="text-right" v-if="btnSale">
                <add-sale :slug="slug" :type-store="typeStore"/>
            </v-col>
            <v-col cols="6" class="text-left" v-if="btnExpense">
                <add-expense :money="money"/>
            </v-col>
        </v-row>
    </div>
</template>

<script>
export default {
    data: () => ({

    }),
    props: ['slug', 'money', 'btnSale', 'btnExpense', 'typeStore'],
}
</script>
